import React from 'react';
import './style.css';
import f_QR from '../../images/footerQR.png'
import footer from '../../images/footer_big.png'

export default function Footer(){
    const footerSectionStyle = {
        width: '80%',
        
    }

    return (
        <div className='App-footer'>
            
                <div className='M_footerInfo'>
                    {/* 왼쪽 텍스트 */}
                    <div className='M_footerTxt'>
                        <p>(주)앤츠네스트 | 이메일 : admin@antsnest.co.kr </p> <p> 대표자 : 용수현 | 사업자번호 : 444-86-03555</p>
                        <p>경기도 용인시 기흥구 강남서로 9,7층 703-제이295호</p>
                        <p>© ANTSNEST DEVELOPER CENTER Co.Ltd. All Rights Reserved.</p>
                    </div>

                    {/* 오른쪽 큐알 이미지 */}
                    <div className='M_footerQR'>
                        <img src={f_QR}/>
                    </div>
                </div>
        </div>



    );
}